import React, { useRef, useEffect, useState } from 'react';
import { useHistory, useParams } from "react-router-dom";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { confirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';
import '../layout/sass/_pickListSugestoes.scss'
import '../layout/sass/_responsiveTable.scss'
import api from '../api/api';
import { InputNumber } from 'primereact/inputnumber';

export const TabelaPessoaMudas = ({ isEditing, pessoaMudas, setPessoaMudas, setListMudas, setQuantidadeTotal, somenteComprovante }) => {
    const toast = useRef(null);
    const [isDeleting, setIsDeleting] = useState(false);
    const confirmationToast = useRef(null)
    const [mudas, setMudas] = useState(false);
    const [atualizarQuantidade, setAtualizarQuantidade] = useState(Math.random());
    let quantidadeTotal = 0;

    const actionBodyTemplate = (rowData) => {
        return (
            <div className="actions">

                <Button
                    type="button"
                    icon="pi pi-trash"
                    className="p-button-rounded p-mr-2 p-button-danger"
                    loading={isDeleting}
                    onClick={() => handleDeleteClick(rowData)}
                />

            </div>
        );
    }

    const codigoBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Código</span>
                    <span className="table-data">{rowData.campanhaMuda.muda.id}</span>
                </p>
            </React.Fragment>
        );
    }

    const mudasBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Nome do Muda</span>
                    <span className="table-data">{rowData.campanhaMuda.muda.nome}</span>
                </p>
            </React.Fragment>
        );
    }

    const quantidadeBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Quantidade</span>
                    <span className="table-data">{rowData.quantidade.toLocaleString('pt-BR')}</span>
                </p>
            </React.Fragment>
        );
    }


    const handleDeleteClick = (data) => {
        confirmDialog({
            message: `Você tem certeza que quer remover ${data.campanhaMuda.muda.nome}?`,
            header: 'Confirmação',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-danger',
            acceptLabel: 'Sim',
            rejectLabel: 'Não',
            accept: async () => {
                setIsDeleting(true);

                try {
                    // 1. Executa a exclusão no back-end primeiro
                    // Caso o item seja novo (ainda não salvo no banco), valide se data.id existe
                    if (data.id) {
                        await api.delete(`/campanhaMudas/${data.id}`);
                    }

                    // 2. Com o sucesso da API, calcula a nova lista sem o item removido
                    const novaListaPessoaMudas = pessoaMudas.filter(item => item !== data);

                    // 3. Atualiza os estados locais
                    setPessoaMudas(novaListaPessoaMudas);

                    const tempMudas = novaListaPessoaMudas.map(item => item.campanhaMuda.muda);
                    setListMudas(mudas.filter(
                        (muda) => !tempMudas.some((pessoaMuda) => pessoaMuda.id === muda.id)
                    ));

                    toast.current.show({
                        life: 5000,
                        severity: 'success',
                        summary: 'Remoção concluída!',
                        detail: `Muda ${data.campanhaMuda.muda.nome} removida com sucesso`
                    });

                } catch (error) {
                    const detailMsg = error.response?.data?.message || error.response?.data || 'Erro ao comunicar com o servidor';
                    toast.current.show({
                        life: 5000,
                        severity: 'error',
                        summary: 'Erro ao remover a muda',
                        detail: detailMsg
                    });
                } finally {
                    setIsDeleting(false);
                }
            }
        });
    };

    const onRowEditComplete1 = (e) => {
        let pessoaMudas2 = [...pessoaMudas];
        let { newData, index } = e;

        pessoaMudas2[index] = newData;

        setPessoaMudas(pessoaMudas2);
    }

    const handleEdit = (data, campo, value) => {
        data[campo] = value;
        setAtualizarQuantidade(Math.random());
    }

    const editarQuantidade = (options) => {

        return <InputNumber value={options.rowData.quantidade} onValueChange={(e) => e.value >= 1 && e.value <= 2 ? handleEdit(options.rowData, 'quantidade', e.target.value) :
            toast.current.show({ life: 2000, severity: 'error', summary: 'Valor inválido!', detail: `Valor deve ser entre uma e duas mudas` })} />

    }

    async function handleGetMudas() {

        const response = await api.get(`campanhaMudas/campanhaAtiva?sort=nome,ASC`);
        let tempMudas = [];
        response.data.forEach(muda => {
            if (muda.quantidade !== 0) {
                tempMudas.push(muda.muda);
            }
            setMudas(tempMudas)
        })

    }

    useEffect(async () => {
        await handleGetMudas();

    }, []);

    useEffect(async () => {
        if (pessoaMudas.length > 0) {
            quantidadeTotal = pessoaMudas.reduce((mudaAnterior, muda) => {
                return mudaAnterior + parseInt(muda.quantidade);
            }, 0);
            setQuantidadeTotal(quantidadeTotal)
        }
    }, [pessoaMudas, atualizarQuantidade]);

    return (

        <div className="card p-grid p-col-12 p-mx-0 p-p-0 p-mt-0">

            <Toast ref={toast} position="bottom-right" />

            <Toast ref={confirmationToast} position="bottom-center" />

            <div className="card p-col-12 datatable-responsive-demo">

                <div className="p-fluid">

                    <DataTable
                        editMode="row"
                        onRowEditComplete={onRowEditComplete1}
                        responsiveLayout="scroll"
                        value={pessoaMudas}
                        className="p-datatable-responsive-demo"
                        emptyMessage="Nenhuma muda encontrada"
                        dataKey="id"
                        paginator
                        rows={10}
                        currentPageReportTemplate="Mostrando de {first} a {last} de {totalRecords} mudas"
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        rowsPerPageOptions={[10, 20, 30]}
                        sortField="nome"
                        sortOrder={1}
                        removableSort

                    >

                        <Column style={{ width: '12%' }}
                            field="mudaId"
                            header="Código"
                            sortable
                            body={codigoBodyTemplate}

                        />

                        <Column
                            field="nome"
                            header="Nome da Muda"
                            sortable
                            body={mudasBodyTemplate}

                        />

                        <Column
                            field="quantidade"
                            header="Quantidade"
                            sortable
                            body={quantidadeBodyTemplate}
                            editor={(options) => editarQuantidade(options)}
                            style={{ width: '10%' }}

                        />

                        {/* <Column
                            rowEditor
                            headerStyle={{ width: '10%', minWidth: '8rem' }}
                            bodyStyle={{ textAlign: 'center' }}>
                        </Column> */}

                        {somenteComprovante &&

                            <Column
                                header="Ações"
                                body={actionBodyTemplate}

                            />

                        }

                    </DataTable>

                </div>
            </div>
        </div>

    );
}
